import axios from 'axios'
import { getToken } from '@/utils/utils'
var md5 = require('./md5.js');
const request = axios.create({
	baseURL: process.env.VUE_APP_BASE_API,
	timeout: 60000
});

// 添加请求拦截器
request.interceptors.request.use(function (config) {
	// 在发送请求之前做些什么
	if (getToken()) {
        config.headers['token'] = getToken()
    }
	// 签名生成
	let timestamp = new Date().getTime() + "";
	let appid = process.env.VUE_APP_ID;
	let sign = "appid="+appid+"&timestamp="+timestamp;
	sign += process.env.VUE_APP_KEY;
	sign = md5.md5(sign).toUpperCase();
	config.headers['sign'] = sign;
	config.headers['appid'] = appid;
	config.headers['timestamp'] = timestamp;
    return config;
}, function (error) {
	// 对请求错误做些什么
	return Promise.reject(error);
});

// 添加响应拦截器
request.interceptors.response.use(function (response) {
	// 对响应数据做点什么
	
	return response;
}, function (error) {
	// 对响应错误做点什么
	if(error && error.response){
		switch(error.response.status) {
			case 400:
				error.message = '错误请求'
				break;
			case 401:
				error.message = '未授权'
				break;
			case 403:
				error.message = '拒绝访问'
				break;
			case 404:
				error.message = '请求错误，未找到该资源'
				break;
			case 405:
				error.message = '请求方法未允许'
				break;
			case 408:
				error.message = '请求超时'
				break;
			case 500:
				error.message = '服务器端出错'
				break;
			case 501:
				error.message = '网络未实现'
				break;
			case 502:
				error.message = '网络错误'
				break;
			case 503:
				error.message = '服务不可用'
				break;
			case 504:
				error.message = '网络超时'
				break;
			case 505:
				error.message = 'http版本不支持该请求'
				break;
			default:
				error.message = `连接错误${error.response.status}`
		}
	}else{
		error.message = '网络出现问题，请稍候再试'
	}
	return Promise.reject(error.message);
});

export default request